export enum ButtonSizes {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}
